import { NativeEvent } from '../NativeEvent';

export class BiometricUnlockEvent extends NativeEvent<
  'biometricUnlock',
  Record<string, never>
> {
  readonly type = 'biometricUnlock';
  readonly payload: Record<string, never> = {};
}
